module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.22.0.0.box.281.642.988.143.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.22.0.0.box.658.642.235.37.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Chapter ")]), _vm._v("I")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.22.0.1.box.281.746.988.39.q.70"
    }
  }, [_vm._v("MY YOUTH ON A SUGAR PLANTATION")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.1.0.box.114.826.1330.1452.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.0.box.114.826.1326.850.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.2.0.0"
    }
  }), _vm._v("The days of my childhood were indeed happy. I lived on \"Retreat Plantation,\" near Plaquemine and our little family comprised Grandmother Clement, her daughter, Henrietta, known to us as Aunt Yetta, my widowed mother and my brother Alfred. We were well supplied with good servants and they were a part of the family life. There was an excellent faithful and happily endowed colored cook, \"Aunt\" Josephine. \"Aunt\" to us younger fry, by plantation courtesy of the old days, was a mark of respect due those older and longservice people of the dark-skinned race who guarded and served us well. Then there was the yard man, \"Uncle\" Anthony, an ex-slave of truly patriarchal appearance. The milkmaid was \"Aunt\" Tilda, who not only milked the four or five cows, but looked after the little dairy under the big, cool cistern, churned the butter and made our delicious brand of cream cheese.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.1.box.114.1699.1330.579.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.2.1.0"
    }
  }), _vm._v("The slightly garrulous \"Uncle\" Ike was our coachman. He took care of the family horses, carriages and buggies and the stable. Ike, in stately array, was driver of the big family barouche on Sundays or special occasions. Ordinarily, however, we youngsters and my mother, did our own driving. I must not fail to mention a grand old white-haired ex-slave, the carpenter, \"Uncle\" Aaron who lived nearby in a little cottage, readily available when his services were required. Two of his daughters still live—or did up until very recently—in this same little old cottage on the plantation. \"Uncle\" Aaron was a terrible stutterer, but a splendid worker. One of his"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.23.1.0.box.137.365.1314.261.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.0.0"
    }
  }), _vm._v("\ndaughters usually served as personal maid to Grandma Clement. Brother Alfred had a small colored boy, George, who acted as his faithful bodyguard. I had \"Little Ike,\" who, likewise, was detailed to play with me and act as my helper when needed.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.1.0.box.136.365.1319.1905.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.1.box.138.652.1316.426.q.60"
    }
  }, [_vm._v("This colored boy \"helper\" arrangement was an old southern custom. The white boy who has not had a colored playmate, as Will Percy that well known Mississippian wrote, has not really lived. But it was a plantation custom and the colored boy was usually slightly older than his white companion. The idea seemed to be that he would thus help train the master's son. Many southerners, who later gained distinction have testified as to the devotion of the two playmates to each other.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.2.box.136.1095.1319.1175.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.1.2.0"
    }
  }), _vm._v("In our home it was a part of the duty of these two little colored boys to take turns in pulling the cord which operated the large \"punkah\" fan over the big dining room table, at meal time. One of these youngsters would seat himself high up on the stairway leading to the attic at the end of the dining room. From that vantage point he would pull the cord which caused the big wooden fan to swing backwards and forwards, keeping the flies off, and helping to cool the diners, often eight or ten people at the table. In those days there were of course no electric fans, yet only a few families seemed to have made even the progress we had in the art of cooling by installing a punkah. The only trouble with this arrangement was that the monotonous pulling of the rope and the swish of the fan induced drowsiness and the little colored boy would—at times— go to sleep. The fan would gradually slow down to nothing. A call from somebody would wake him up and we would be favored with a furious pulling of the cord for a while. Then if the soporific tendency asserted itself again, there would be another slow down and another harsh return from dreamland. Even so, the arrangement worked out nicely and visitors always seemed to remember our punkah and would congratulate the family on this idea.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.1.0.box.133.371.1337.1730.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.0.box.140.371.1330.1177.q.60"
    }
  }, [_vm._v("Our rambling old Retreat Plantation* house with its many log-fire chimneys and outer \"galleries\" centered around a main building with a most comfortable, old-fashioned large living room into which visitors walked after being received hospitably at the main entrance. Two ells reached out from the two rear corners in opposite direction, one contained large extra bedrooms, the other kitchen, store-rooms and laundry. There was ample room for the family, and accommodations for the flow of guests from New Orleans—dear ones, friends and relatives who were almost constantly coming and going— much to the enlivenment and interest of all, especially for my brother and myself. It was quite usual for guests to bring with them when they came from New Orleans, candy, cakes, pate de foie gras and all kinds of delicacies—those special confections and importations quite unobtainable in our plantation section. Our \"big house\" was a one-story affair and small compared to the more palatial two-story Gay home not far away. It was whispered around among the youngsters that, while our cousin Edward J. Gay of about our age was domiciled in a room on the ground floor, his colored nurse used to take him upstairs occasionally, so as to \"make him high-minded.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.1.box.133.1572.1328.529.q.60"
    }
  }, [_vm._v("The Clement house fronted on a plantation road, which ran to the main riverside highway—the road running alongside the levee and Mississippi River. In the other direction the plantation road passed through the \"quarters\" where the little houses of the colored workers stood, then on to the sugar house mill, and back to the woods. Our house was about a half mile back from the river. A white-washed picket fence enclosed the big front yard, which included a number of lovely trees, rose bushes, old fashioned camellias and sweet magnolias. Branching off from the house was a side yard containing a large"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.25.1.0.box.147.365.1317.430.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _vm._v("\nnumber of fruit-bearing orange trees. In the rear was an extensive vegetable garden, and an orchard of fruit trees, such as peach, pear, a grape arbor—all in good bearing condition. There was a large group of fig trees of the delectable \"Celeste\" variety. Each year we had a big time gathering the figs during a period of several weeks. The excess crop was made into preserves, to be kept for later consumption or shipped to favored relatives and friends.")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "block.24.2.0.box.130.2132.1325.161.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.2.0.box.130.2132.1325.161.q.60"
    }
  }, [_vm._v("*Retreat Plantation was so named at time of the Civil War when grandfather Clement, apprehending danger from Federal gun boats stationed in front of Plaquemine, thought it best to move his family to the safety of his plantation home. Hence the name \"Retreat\".")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.1.0.box.147.365.1333.1912.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.1.box.151.820.1325.959.q.60"
    }
  }, [_vm._v("On the other side of the plantation house was the carriage house and other small out-buildings. In the back yard was the great oak which many visitors have written about. A central point for the grouping of vehicles, a shade place for animals in the heat of the day, this big tree unfortunately—in my early youth—had already met death's withering hand. I can remember its great dead branches reaching up starkly to the sky. It was quite a while however, before it was cut down for use in the woodpile. The woodpile, by the way, was no mean affair. Not only was it the entire source of heat for the winter, big log fires kept going all day long, but all the cooking and water heating the year round was done with wood fuel. Up in \"town\" some people were commencing to use coal in smaller grates and in stoves. We scorned anything like that as being dirty and smelly. Many country folk to this day, notwithstanding efficient central heating systems in their city or country homes, must still have their log fires—or else winter loses one of its chief joys.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.2.box.160.1795.1320.359.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.2.0"
    }
  }), _vm._v("That great dead tree, before it was cut down commenced to attract occasional groups of turkey buzzards. Those keen visioned but horrible looking vultures, scavengers of the neighborhood, liked the vantage point of the high-up bare limbs. These big birds, as everyone knew, were protected by law, but that did not prevent us from casting a baleful eye on the intruders.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.3.box.164.2177.1315.100.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.3.0"
    }
  }), _vm._v("One morning, in fun and in a boyish spirit of adventure I turned my little \"twenty two\" rifle on a buzzard up in the old"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.26.1.0.box.130.371.1325.654.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _vm._v("\ntree. I did not think my rifle could reach that high, or bring down such a big tough bird. To my horror the big buzzard did not fly away, but turned over without a struggle, the ghastly looking thing falling dead at my feet. My aim had been far better than I thought it would be. Immediately I destroyed \"the evidence\" by dropping the ugly corpse down a nearby abandoned well. Even so my guilty conscience had me in a funk whenever I saw strangers coming down the road to our place. I would think, \"the jig's up, here's the sheriff to put me in jail.\" Probably my tender years plus the prestige of the family would have saved me, but I suffered nevertheless, no one gave aid or any comfort whatever.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.1.0.box.130.371.1332.1922.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.1.box.134.1041.1323.376.q.60"
    }
  }, [_vm._v("But the big dead tree was later to furnish birds of another kind. A pigeon house was built in the lower section of this old tree. Grandmother was fond of succulent and tender squabs, and, by keeping the pigeons well fed, we had an almost continuous supply of this delectable addition to the menu. In the backyard we had, as is usual on farms, a number of chicken and turkey roosts or houses.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.2.box.134.1432.1326.640.q.60"
    }
  }, [_vm._v("Our plantation food production was largely a self-supporting or self-contained affair. Sugar and molasses were in abundance, as that of course, was our main business. Very little food was bought on the outside except coffee, tea, ice, and a few other table delicacies. In our garden were grown in profusion many vegetables including the artichoke, loved by gourmets. In season we always had plenty. It seems a little unusual, but at our place we had tobacco plants growing in the fence corners of our yard. The big leaves were put up in the attic of the barn to dry and cure. Well do I remember shredding the leaves after they had dried into a sort of crimp-cut condition and then packing them in small bags for use.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.3.box.135.2087.1327.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.3.0"
    }
  }), _vm._v("When short of pocket money we boys would have the cook make a big freezer full of ice cream, packed with plenty of ice. We would load it in a spring wagon and go over to a neighboring plantation where the \"hands\" were being paid off. A"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.27.1.0.box.132.365.1314.102.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.0.0"
    }
  }), _vm._v("\nquick \"sell out\" of our ice cream and little tobacco bags—all at low prices—no taxes included—was generally effected.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.27.1.0.box.132.365.1321.970.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.1.box.133.476.1318.591.q.60"
    }
  }, [_vm._v("Fitting in with the plantation economy of producing what, ever goods could be made by local handicraftsmen and thus keeping the money at home, my aunt, at the proper time of the year, would send us boys to the woods to cut strips from the palmetto shrubs growing in profusion there. These strips were dried, sliced into proper sizes, plaited into long sections and then sewn together and shaped into hats and bonnets. Lined with cheap cotton and of light-weight, both the broadbrimmed hats for men and sunbonnets for the women were effective in protecting the wearers from the actinic rays of an almost tropical sun.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.2.box.137.1076.1316.259.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.2.0"
    }
  }), _vm._v("Palmetto leaves were also used to make fans. We thought it much fun to cut palmettos and never objected to the chore. Probably today in Louisiana not many know how to make hats, and not many bonnets are worn. But whether the palmetto is plentiful or not I do not know.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.2.0.box.137.1402.1320.875.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.27.2.0.box.513.1402.565.38.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.2.0.0"
    }
  }), _vm._v("Annual ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Pecan ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Harvest ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.2.1.box.137.1480.1318.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.3.0.0"
    }
  }), _vm._v("Each year in the fall, Aunt Yetta would marshal together a crew of youthful helpers, white and black, to get in our big crop of pecans. Dozens and dozens of barrels would be filled, many finding their way to the waiting New Orleans market— usually with a good cash return.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.2.2.box.137.1748.1320.529.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.3.1.0"
    }
  }), _vm._v("A picturesque feature of this annual pecan event was \"thrashing\" of the branches of the pecan trees with a long pole. This required the services of an expert \"thrasher\". Tom Cowan, a local colored man, made a sort of specialty of this kind of work. Climbing a tree he would venture far out on a limb and with his pole bring the nuts raining to the ground into the hands of us children engaged as \"pickers\". Tom after successfully doing our thrashing work for years, climbing around the big trees, once foolishly and surreptitiously took a bottle of whiskey up with him, hiding it somewhere in a crotch"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.28.1.0.box.136.371.1325.608.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  }), _vm._v("\nof the tree. Frequent reference to this cache of intoxicating treasure eventually proved Tom's undoing. His fatal misadventure entailed also a narrow escape for the writer of this page, then ten years old. I was working under the colored climber at that time. Well do I remember the awful thud as his huge body hurtling down from above hit the ground. It fell within a few feet of me, as I blanched with fear. The unconscious and partly intoxicated exthrasher was carried off the field with broken legs, arms and serious internal injuries. Tom died from that terrible fall, a dire warning to all secret drinkers, one which did not go unnoticed.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.1.0.box.130.371.1331.1905.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.1.box.134.995.1325.749.q.60"
    }
  }, [_vm._v("Aunt Yetta was an excellent business woman, and after the death of my father, Alfred H. Clement, Sr., it was she who managed plantation jobs such as pecan gathering, kept the books, and \"bossed\" things generally. The job she liked best was the management and direction of our big pecan harvest. At times we had an \"overseer\" or manager who lived on the place, but more often \"Retreat\" was run by my dear, semiinvalid aunt. I can see her now almost overcome by asthma and at times afflicted with other serious disabilities—bravely struggling to keep going. \"Miss Henretta\", as the colored folk called her, the tall slender maiden lady, was a tower of strength. In her kindly, quiet, but determined and able way she was the one who made possible the continued operation of the plantation.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.2.box.130.1760.1327.516.q.60"
    }
  }, [_vm._v("In a pasture adjoining the main house, we raised a large number of sheep, providing fresh mutton for the table. Mother would never allow us youngsters to see the killing of sheep or hogs. She thought the effect bad on children and that it tended to make them hard-hearted and cruel. They must not become inured to death and like the Vestal Virgins point their thumbs down to signal for the slaughter of living things, nor see the despair in the frightened eyes of the poor sheep or hogs that met death the plantation way—by having their throats cut.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.29.1.0.box.134.364.1341.1916.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.0.box.134.364.1318.375.q.60"
    }
  }, [_vm._v("We had sheep-shearing times at Retreat also. When the wool was gathered it was treated for cleanliness. Some of it was used on the plantation. We boys used to help Aunt Yetta in the processing called \"carding\" wool. Later these \"cards\" of fluffy wool were sewn into \"comforters,\" or made into rough garments. Much of the wool production was sent to the New Orleans market.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.1.box.139.765.1328.1071.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.1.0"
    }
  }), _vm._v("The shrimping season brought each year a pleasant variety in our table menu and some excitement for us. Beginning in the late spring it lasted four or five months. We caught the shrimp by placing shrimp-boxes in the Mississippi River, out in front of our place. These boxes were kept filled with table refuse, ham-bones, or cantaloupe rinds together with a little cornmeal, which attracted quantities of shrimp into these home-made traps. Once in, the shrimp were unable to get out. We youngsters always welcomed the opportunity to go swimming in the river, while bringing these moored boxes to shore. Often the boxes would be emptied of enough shrimp to fill several tubs and washpans. These delicious crustaceans would be made into a savory shrimp \"gumbo\" Aunt Josephine was noted for, or boiled and served on an immense platter—enough for everyone. Boiled river shrimp eaten cold with salt and pepper was a standard dinner entree nearly every day in the summer. There is no greater delicacy than Mississippi River shrimp. They are smaller but the flavor is more subtle than the larger gulf shrimp—truly a dish for an epicure.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.2.box.155.1854.1317.310.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.2.0"
    }
  }), _vm._v("It was during the shrimping season that we developed as swimmers. Especially was this true when our Cousin Edwin Schlater visited the plantation. He it was who taught us the fine points. An expert and an unusually strong swimmer, he took pleasure in showing us how to improve ourselves in this necessary art.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.3.box.158.2181.1317.99.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.3.0"
    }
  }), _vm._v("\"Cousin Ned,\" as we affectionately called him, used also to take us hunting. Equipped with a good gun, and an extra fine"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.30.1.0.box.130.370.1322.331.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.0.0"
    }
  }), _vm._v("\nhunting dog, we always brought home large strings of birds. It was not long before we boys were allowed to own small guns, and soon we hunted on our own, bagging birds, squirrels and rabbits. In those days small game was much in evidence on the plantation, and there were no game laws to bother us. We regulated things to suit ourselves.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.30.1.0.box.130.370.1327.1921.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.1.box.131.719.1322.423.q.60"
    }
  }, [_vm._v("Once I shot a wild cat—or so it was thought to be—near Bayou Le Butte, a meandering little waterway back of our place. The stealthy, powerful looking animal was crossing the bayou on a fallen tree and I happened to be concealed nearby. It was indeed an exciting moment. I shot but the distance was too far and the bird shot scattered. With a terrific snarl the animal leaped into the air, then, fortunately for the boyish hunter, left the field to him and his little bird-shot gun.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.2.box.130.1159.1324.578.q.60"
    }
  }, [_vm._v("In another hunting experience I remember coming suddenly on a big fat opossum lying, apparently dead, in our back yard. This time there was no danger. Feeling him still warm, I went off to get help in bringing in the prize. When I returned the big fellow was gone. He had had presence of mind enough to play that \"possum\" trick—when he found I was right on top of him. It was quite evident that he was preparing to invade our chicken roost. Well, I had to learn. Our colored retainers would have greatly enjoyed a \"possum and taters\" dish, had the young hunter used a club to finish off the marauder at once.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.3.box.131.1761.1326.530.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.3.0"
    }
  }), _vm._v("At Retreat the first thing you heard in the morning was the coffee grinder as Aunt Josephine prepared the coffee, which was roasted fresh every morning. We youngsters of course did not get morning \"coffee in bed\", southern style, like the older folks, but we did get it at breakfast, served with hot milk. I still remember how good it was. No one serves coffee like that now. Coffee in those days was not \"assembled\" or blended with chicory —it was all Mocha and Java. At regular intervals our New Orleans agent, W. B. Bloomfield, shipped us two hundred-pound bags of coffee—one Java"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.31.1.0.box.132.363.1315.432.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.0.0"
    }
  }), _vm._v("\nand one Mocha. Every day Grandma with her big bunch of keys made a trip to the storeroom. She would give out, along with other provisions like flour, meal and sugar, the green coffee for the next day—equal amounts of each variety which \"Aunt Josephine\" mixed that afternoon, roasted and then ground the first thing next morning. It has been years since this writer smelled the delicious aroma of coffee roasting on top of a stove, but the memory lingers.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.31.1.0.box.132.363.1323.1908.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.1.box.135.812.1316.479.q.60"
    }
  }, [_vm._v("I mentioned the gumbo file with shrimp, but overlooked the crayfish bisque which was one of Josephine's specialties—and crayfish were plentiful in the big plantation drainage canals. Mother would often take us crayfishing when we were very small. All that was needed was a few little chunks of salt meat, a piece of string and a short pole, together with a good net on a long pole. Another specialty of Josephine's was okra gumbo, using shrimp, chicken or crabs as a base. It was superior to gumbo file and one of the most delicious dishes I ever tasted.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.2.box.137.1308.1318.894.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.2.0"
    }
  }), _vm._v("Once I found a \"cap and ball\" revolver in the \"Retreat\" attic. This was one of Colt's earliest efforts and was really an antique. I saw one like it recently in a collection of old guns, and the owner valued it at $250. Now a collector's item they are very scarce. We boys would load it with powder and shot, then stick on the required percussion caps. Occasionally all six chambers would go off at once. When that happened the only safe place in the neighborhood was immediately behind it. While most of the hunters of those days were still using the old-fashioned \"muzzle loaders\" with ramrods, powder horns and caps, we possessed one of the early-model Parker double-barrel breech-loaders. This was a hammer gun but a really fine piece, and man-size. There were no ready-loaded shells in those days, and we bought empty shells, powder and shot, loaded our own shells with a set of tools that came with the gun. All of this outfit had belonged to our deceased father.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.3.box.191.2224.1264.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.3.0"
    }
  }), _vm._v("My brother Alfred and I used to take this practically-new"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.32.1.0.box.129.371.1323.495.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0"
    }
  }), _vm._v("\ngun and the ancient revolver and go hunting accompanied by our two colored retainers, Ike and George. We would take turns shooting. It is a wonder no one ever was injured. We frequently brought in fairly good bags of game—I do not recall a single mishap. We could not have been over nine and ten, respectively, when we started using these weapons. What would a person think today of two little boys of nine and ten going hunting with a double-barrel, twelve gauge, shotgun and a forty-five caliber Colt revolver.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.1.0.box.129.371.1326.1922.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.1.box.131.884.1324.799.q.50"
    }
  }, [_vm._v("Resourcefulness and determination are almost necessary attributes of the small boy on a plantation. At a young age one learns to develop initiative and not to be afraid. I well recall, while hunting alone on the riverfront, shooting my first wild duck and then seeing the much coveted duck—big game to me at that time—floating down the Mississippi river about 75 feet out from shore. To go home and tell of my prowess without the duck would get me nowhere. Having no \"retriever\" dog, notwithstanding winter weather and icy cold water, it was up to me to do the retrieving, or see my duck disappear in the offing. So, without hesitation I took off my shoes and clothes and swam out into the big river. Soon I was back on the shore with my prize. I dressed and went happily on the way home at a warm-up trot, none the worse for my experience.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.2.box.132.1706.1322.259.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.3.0.0"
    }
  }), _vm._v("It might be a little difficult for city-bred boys to believe that such crazy, life-risking experiences were ordinary happenings for youngsters like us out in the country. However, sometimes the country man with his careless \"gun play,\" came to grief as parish records show.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.3.box.130.1980.1324.313.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.3.1.0"
    }
  }), _vm._v("I must chronicle here a boyish sporting event in which my little colored retainer, Ike, appeared as hero. He was somewhat malformed. His left hand was what he himself called a \"nub,\" almost useless. In addition to good use of his extra strong right hand, he could whip larger boys by butting them with his extremely hard, bullet-shaped head. In fact, he"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.33.1.0.box.133.365.1315.273.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0"
    }
  }), _vm._v("\nachieved considerable local fame for butting pickets off of the fence, which tour de force he would perform for a dime. \"Billy,\" the plantation goat, one of my much-loved four-footed pets, had also acquired quite a reputation as a \"butter,\" having vanquished all the goats and rams in the neighborhood.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.1.0.box.133.365.1321.1915.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.1.box.134.654.1316.540.q.60"
    }
  }, [_vm._v("One day a group of the plantation boys were discussing the powers of the two champions. A purse of Me was subscribed and Ike agreed to swap butts with Billy for the championship and the purse. He got down on his hands and knees and awaited for the onslaught, after emitting a challenging B-a-a! Billy took time out to think things over. He took so long that Ike looked up to see what was the trouble, just then Billy reared up and came down with a crashing butt square on Ike's forehead. Billy scored a knock-out and complete victory. Ike had to be rescued from further mayhem.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.2.box.135.1212.1319.1068.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.2.0"
    }
  }), _vm._v("I don't remember ever \"learning\" to ride a horse—I rode and had horses to ride as far back as memory goes. But I do remember many of the horses, including the mountainous-insize, Pet, the smaller Prince, Lookout and a wiry little Indian mustang pony used as transportation to school. I remember a lot of the mules too and some of the names, including \"Fashion,\" the mare mule that killed Aunt Josephine's only boy, a sad and terrible happening. Most mules are stolid, easy going, rather safe animals to deal with. However, the child somehow enraged this powerful and somewhat \"ornery\" animal. By a sudden rear-end kick, she broke his neck causing almost instant death. This seems to have been the only mule-engendered fatality of the kind that occurred on the plantation during my time. The tragedy may have had something to do with the fright that came later when one of a party of little girls—cousins visiting \"Retreat\"—on being dared by her playmates, suddenly ducked her head and ran under one of the mules standing in the backyard. Fortunately nothing happened except a resultant reprimand and stern lecture to the little one, who in this case was no less a personage than the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.34.1.0.box.130.373.1320.100.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0"
    }
  }), _vm._v("\nfuture Mrs. Anna Gay McClung, daughter of Andrew H. Gay, of nearby St. Louis Plantation.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.34.1.0.box.130.373.1328.925.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.1.box.132.485.1324.484.q.60"
    }
  }, [_vm._v("I remember also the great excitement created when one of the mules fell into the underground cistern at the nearby big barn, and the futile efforts to rescue it. That scene, on a cold winter's night, with a dim lantern on a rope throwing its fitful glare on the poor mule thrashing around in the water twenty feet down — uttering strange and awful cries — while the hostler and the Negroes made vain attempts to get ropes under it, is as vivid in my memory today as if it had happened last night.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.2.box.135.979.1323.319.q.60"
    }
  }, [_vm._v("I also remember that big snow in 1889, when the whole country seemed to freeze. It killed our beloved orange trees and did much other damage. It was the first show I ever saw, and the last, until that still greater one in New Orleans, years later in 1895, the time when the Mississippi river was full of floating ice cakes.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.34.2.0.box.137.1362.1326.932.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.34.2.0.box.350.1362.895.39.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.0.0"
    }
  }), _vm._v("\"Open ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Kettle\" ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Sugar ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Mill ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Operation ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.2.1.box.137.1442.1325.801.q.60"
    }
  }, [_vm._v("My earliest recollection of sugar making on the plantation was of a little mill that had run for many \"grinding\" seasons during the time of my father and grandfather. The Clement mill, however, was dismantled in later years, and the cane sold to larger mills nearby. But when I was a little boy the old fashioned sugar mill operated in all its glamour, and for the last two or three months of the year it was the momentous concern of all the plantation people, white and black, young and old. Big slabs of wood, from nearby stacked cords of this home-produced fuel, thrown or pushed into blazing fires under the big old-fashioned boilers, was a spectacle in itself. A cane \"carrier\" brought the great piles of juicy looking \"ribbon\" cane to the crushing rollers. The cane juice flowed in a small river to the row of \"batteries\" where the boiling and \"skimming off\" of impurities took place.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.2.2.box.192.2249.1271.45.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.1.0"
    }
  }), _vm._v("These batteries of \"open\" kettles or cauldrons with steam"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.35.1.0.box.132.365.1317.1250.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.0.0"
    }
  }), _vm._v("\ncoils underneath were arranged in order. The transfer of the hot juice from one to the other was done by a hand-operated ladling process, amid a steamy surrounding, with much sampling and testing to find when the point of proper cooking had been reached. Great long sweeps with wooden buckets were the ladles that carried the boiling cane juice from one cauldron to the other and to the final-process vat before it was transferred to coolers in the \"cooling room.\" There the soft sugar mass was left to solidify into the brown sugar, the finished product. Later, men with ordinary spades dug the brown sugar out of the coolers and filled sugar barrels and hogsheads for shipping to New Orleans. Some of the juice ended up as our Retreat Plantation "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Delectable ")]), _vm._v("brand of molasses. Molasses of course was handled differently, and was poured into a tighter barrel. After each boiling when the molasses was cooled off there remained at the bottom of the kettle a thick substance called "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cuite. ")]), _vm._v("This ropey, taffy-like confection was a table delicacy with the flavor of sugar cane and was much enjoyed during the season. It could not be kept long without turning into sugar. Cuite is now almost a non-existent product. Once in universal use, the \"open kettle\" system such as ours is now extinct. At one time there were hundreds, now only one or two left — if that.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.1.0.box.130.365.1319.1909.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.1.box.130.1631.1319.468.q.60"
    }
  }, [_vm._v("All these little old-time mills, one on practically every sugar plantation — some horse operated, some steam — making the simplest form of plain brown sugar, had their own cooper shop attached. There barrels were made and put together. The work was done by home-trained expert Negro coopers. After the barrels were filled four-mule carts hauled them out along the road in front of our house, over the levee and down to the boat landing where they were loaded on a steamboat to be taken to New Orleans.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.2.box.130.2123.1317.151.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA1.w.0.0.0"
    }
  }), _vm._v("The transport of the "), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA1.w.1.0.0"
    }
  }), _vm._v("weighty hogsheads of "), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA1.w.2.0.0"
    }
  }), _vm._v("sugar was effected by"), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA1.w.3.0.0"
    }
  }), _vm._v(" a special lifting ap"), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA1.w.3.1.0"
    }
  }), _vm._v("paratus, which hoiste"), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA2.w.0.0.0"
    }
  }), _vm._v("d the great casks and"), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA2.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA2.w.2.0.0"
    }
  }), _vm._v(" hung them under and "), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA2.w.3.0.0"
    }
  }), _vm._v("between two big wheels to"), _c('a', {
    attrs: {
      "id": "GBS.PA14-IA2.w.3.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.38.1.0.box.135.375.1325.488.q.60"
    }
  }, [_vm._v("\nform a novel conveyance. Queer looking rigs these were, generally pulled by oxen, traveling at a slow pace with the big barrel-shaped container hanging only a few feet from the ground. In bad weather, when the roads were deep with mud, hauling entailed great difficulties. But there was no trouble in getting steamboats to take on this freight as it stood on the bank of the river. I remember freight agents from the boats coming to our home and pestering our p"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.0.0"
    }
  }), _vm._v("eople for business.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14-IA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.36.1.0.box.0.123.1567.869.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0013.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_inset_box",
    attrs: {
      "id": "block.36.2.0.box.0.1485.489.566.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14-IA1.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_inset_box gtxt_lineated",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "id": "para.36.2.0.box.0.1493.486.540.q.50"
    }
  }, [_c('i', [_vm._v("Right")]), _vm._v("—Messrs. Charles Ed- "), _c('br'), _vm._v("ward Grace, Notary (left); "), _c('br'), _vm._v("Joseph Allain Grace (cen- "), _c('br'), _vm._v("ter), Clerk of Court of Iber- "), _c('br'), _vm._v("ville Parish for nearly 30 "), _c('br'), _vm._v("years and brother of Albert "), _c('br'), _vm._v("L. Grace, author of \"Heart "), _c('br'), _vm._v("of the Sugar Bowl, the Story "), _c('br'), _vm._v("of Iberville\"; and Stuart O. "), _c('br'), _vm._v("landry (right) of New Or- "), _c('br'), _vm._v("leans. This picture was taken "), _c('br'), _vm._v("in front of the Grace law "), _c('br'), _vm._v("office at Plaquemine by W. "), _c('br'), _vm._v("E. Clement when the author "), _c('br'), _vm._v("was gathering material for "), _c('br'), _vm._v("this book. "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.36.3.0.box.490.1352.1090.1213.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0014.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14-IA2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.37.0.0.box.4.0.1590.2550.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0015.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.2.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.38.1.0.box.130.375.1330.1923.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.1.box.130.887.1327.1411.q.60"
    }
  }, [_vm._v("The forest in rear of our plantation did not supply quite all the wood that was needed to \"take off\" the sugar crop. So each spring, when the river-rise brought great logs down the river, a gang of our colored workers using four-oared skiffs would go out into the stream and bring to shore some of the largest of the constantly passing uprooted trees. These logs, some of them of great size, were drawn from the water edge to the working area high on the bank by means of hand windlasses. Round and round the men went pulling out the logs. Some times a small horse was used to pull the big lever around. The logs were then sawed in proper lengths by hand, two men with cross-cut saws. By using axes and wedges, the sawed sections were split into \"slabs\" for the sugar-house furnaces. They were then piled to dry for the coming \"grinding\" season. I remember going out to the river-front one cold freezing day to watch the colored workers do this fast-moving \"assembly line\" work. I asked the foreman why the men did not have a fire burning. His answer was, \"when we get going we don't need no fire, we heats up on the job.\" The Negroes have an old saying that \"when you'se young you heats from the inside out, when you gits old you heats from the outside in.\" In talking recently with former U. S. Senator Edward Gay about this rather primitive fuel operation of the sugar making process of many years ago, when compared to modern oil burning equipment now used in most all the big sugar mills, he said, \"Yes I remember the old method.\" \"But in those days,\" he"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.39.1.0.box.131.364.1314.102.q.70"
    }
  }, [_vm._v("\nsaid, \"The sugar mills made a lot more money than they do at present.\"")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.39.1.0.box.131.364.1314.102.q.70"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.39.2.0.box.132.486.1326.1790.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.39.2.0.box.499.486.571.36.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Lanterns ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("On ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Levee ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.2.1.box.132.559.1322.1284.q.60"
    }
  }, [_vm._v("The levee played an important role in the lives of all. I must tell of the tension and fear which weakness in these little levees provided us with in the old days in Iberville Parish. The effectiveness of these small dykes, built by hand labor with wheel barrows, against the power of the great river they were dedicated to holding back gave us much concern each year. I recall vividly the anxious days and weeks our people went through each season when the river kept rising and rising, and \"revetment\" by means of outside planking and sandbags became necessary. I saw the hungry waves lapping over a little at places when big boats passed, thus softening and weakening still further the narrow little barriers which kept us and our belongings from being swept away. Men with lanterns constantly patrolled the levees night and day, watching for the beginnings of breaks, the crayfish holes and \"boils\" which sometimes spouted up under the hydrostatic pressure. It was only when these leaks could be found that there was a possibility of foreseeing or preventing a break. After even a small section of the levee \"went out\" there was seldom any stopping the rush of water. Fortunately for us no break-through or \"crevasse\", occurred at our place during the time I was there. This was due perhaps to the fact that the crevasses that occurred above us took the pressure off our poor little levee about to collapse.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.2.2.box.140.1857.1318.419.q.60"
    }
  }, [_vm._v("The levees at that time were kept up by assessment of the property owners in the various levee districts. Not much money was available for this purpose. Of late years this job has been taken over by the national government and the machine-made embankments of today are very different looking affairs from those of seventy years ago. But even as late as 1927 when the river rose to record breaking heights there was loss of life and widespread property damage.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.40.1.0.box.110.371.1328.1918.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.40.1.0.box.627.371.301.36.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("School ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Days ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.1.box.114.450.1324.983.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.0.0"
    }
  }), _vm._v("When the time came for school, we boys and girls of the neighborhood were fortunate in having available the services of Cousin Eliza Kent, a widowed grand-daughter of the late planter, Nicholas Wilson, and a great grand-daughter of the developer of the section, Captain Joseph Erwin. On our mother's side we boys of Retreat Plantation were also Erwin descendants, as was Edward Gay on his father's side. The six, school-age Dickinson youngsters and the five boy-and-girl Craigheads were also scions of the same stock. In fact most of us were \"two way\" cousins. Besides these youngsters there quite a few others of the neighborhood, making a fair sized school attendance. The little one-room school was on our Uncle Andrew Gay's property and, to reach it, we of Retreat, were forced to ride about four miles on horseback. Cousin Eliza, let me respectfully say, was something of a martinet, maintaining strict discipline and order. However, she was a most able and experienced teacher, having taught many of the previous generation, our fathers and mothers.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.2.box.111.1444.1323.373.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.1.0"
    }
  }), _vm._v("As I look back on the instruction given there as compared to the general teaching of today, the high ideals our teacher very determinedly and ably tried to implant in the minds of her young flock, I cannot but give thanks that my early views and training were so much influenced by the teachings and morals of our strong-minded Cousin Eliza. There was no slurring over anything.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.3.box.110.1825.1322.464.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.2.0"
    }
  }), _vm._v("Recently there has been a revival of interest in the McGuffey Readers that were used in the schools all over America. In studying them I was influenced by the emphasis placed on the fundamentals of truth, honesty, fair dealing, invention and self-reliance. The preposterous and destructive idea that \"everybody is entitled to a living at the expense of the state\" has no place in these splendid books. McGuffey's first reader had a little poem which conveyed a valuable hint on the virtue of work:")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.41.1.0.box.130.368.1329.1917.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    attrs: {
      "id": "para.41.1.0.box.397.368.677.212.q.60"
    }
  }, [_vm._v("The Lark is up to meet the sun, "), _c('br'), _vm._v("The bee is on the wing, "), _c('br'), _vm._v("The ant its labor has begun, "), _c('br'), _vm._v("The woods with music ring. "), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    attrs: {
      "id": "para.41.1.1.box.393.618.812.202.q.60"
    }
  }, [_vm._v("Shall birds and ants and bees be wise, "), _c('br'), _vm._v("While I my moments waste? "), _c('br'), _vm._v("Then let us with the morning rise "), _c('br'), _vm._v("And to our duties haste. "), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.2.box.140.870.1319.265.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.0.0"
    }
  }), _vm._v("Maybe all this sounds old-fashioned and out of harmony with the educational ideas we hear today. Moreover I would have felt sorry for anybody who delivered himself of any such modern educational theories before Cousin Eliza. That would have been heresy indeed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.3.box.140.1151.1319.203.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.1.0"
    }
  }), _vm._v("Discipline as I have indicated was strictly enforced. Never was there a chance for revolt of any kind. Our parents stood solidly behind Cousin Eliza. They knew she was the epitome of all that was right and fair.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.4.box.134.1371.1323.640.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.2.0"
    }
  }), _vm._v("In the large pasture playground surrounding the school, there was ample room for ball games, Indian fighting, and foot races. The writer of these lines one day distinguished himself when playing \"catcher\" by running too fast to a big fence post. At high speed he scraped against a barb-wire fence. The barbs tore a large piece of flesh out of his leg near the knee. A long, livid scar from that encounter remains until this day. The big flow of blood was stanched by using pretty much all the cobwebs the school ceilings could muster, and the wound was bandaged with two handkerchiefs. Wonderful indeed is youth. I even rode home that evening on horseback. Not much coddling in those days.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.5.box.130.2025.1323.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.3.0"
    }
  }), _vm._v("After lessons we boys would saddle our ponies and start gayly for home. Quite frequently a race would take place, sometimes with casualties that, as we look back on those falls from speeding horses, came desperately near being broken necks. Often the ride home would be interrupted by a swim in"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.42.1.0.box.139.372.1324.375.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _vm._v("\nthe river. Once this nearly resulted in tragedy. The river was rising rapidly and the place we selected for the swim that day was perhaps the most dangerous along the river. A headland or old \"levee point\" reached out obliquely into the big stream, partly enclosing a \"batture,\" where the rising water swirled in to fill the partly empty space between an old and new levee.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.42.1.0.box.130.372.1334.1917.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.1.box.136.774.1328.862.q.60"
    }
  }, [_vm._v("Brother Alfred, elected to swim out a little way from this outside point to a partly submerged oak tree and then come back to where the group was disporting itself. To our horror we saw that on his return he was unable to breast the strong current and that he was too exhausted to go around the long way to safe ground. Immediately one of the boys, Alvin Dupuy and myself swam out to save him. Alfred was going under for the last time when we reached him. All he could say was \"Leave me, save yourselves.\" We seized him one on each side, and endeavored to make headway to the nearby point of land against the rushing stream. Charles Dickinson helped by meeting us with a log. Though we were unusually strong swimmers, we couldn't do any more than hold our position, and it began to look like we could not do that much longer. Soon we would all go under and three or more names would be added to the river's long list of victims.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.2.box.130.1655.1328.634.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.2.0"
    }
  }), _vm._v("Fortunately a lad, Sam Mathews, who had remained on shore, ran out on the point with a long pole. He reached out as far as he safely could and shoved the end of the pole to us. I was able to grasp it, and thus the group, holding to each other, were pulled back to safety. Alfred was laid on the incline of the levee with his head down so the water could run out of his lungs. In a short time a bunch of scared and contrite boys was ready to resume the journey home. At the time we said nothing about this to our mother. I have often thought how awful it would have been if, on that day news had been carried to the recently bereaved widow — that she must now face the death of her two children in a double tragedy.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.43.1.0.box.135.364.1330.1915.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.0.box.135.364.1317.878.q.60"
    }
  }, [_vm._v("With racial conflict arising between white and blacks today, being promoted sometimes, as I believe, for political reasons, I like to think of the harmony and good feeling that existed between the two races on our place following the stresses and strains of the Civil War. I remember one Christmas when, because of bad weather and consequent impassable roads, there appeared to be no chance of a visit from Santa Claus. A heart-breaking disaster for the children. The only way to get to town was to walk there on the top of the levee. \"Young Anthony,\" son of our yardman and ex-slave, Anthony, did this for our mother. Putting on big boots it required all his strength to walk in the mud against a freezing rain and cutting wind. He made the trip and brought back the presents. The big day was thus saved for us through help of a colored man who could not bear to see the white children saddened and disappointed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.1.box.141.1258.1318.529.q.60"
    }
  }, [_vm._v("Christmas was always the occasion for a fire works display at the Big House (not very big, but that was planter's parlance for a plantation owner's home). Not only did we boys enjoy shooting off fire crackers, but the entire neighborhood joined in, including the colored children from the nearby \"quarters.\" Sometimes there were a few burns and casualties from the ample number of small Chinese crackers, cannon crackers, skyrockets, roman candles and pin wheels, but nothing serious ever happened. We not only enjoyed the show ourselves, but enjoyed seeing the other children so happy.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.2.box.146.1804.1319.475.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.2.0"
    }
  }), _vm._v("Recently there has come into vogue a theory that the romantic writings of Sir Walter Scott have had a fuedalistic and unhealthy influence over the elders and youth of the South. Our reading as youngsters was largely of these great books and similar romances found in our father's library. But many southerners feel that only good came from such oldfashioned and high minded reading as Scott's Ivanhoe and his other books in the formative years. One result of this was that we boys made long \"jousting spears,\" with guards near the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.44.1.0.box.116.371.1322.317.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  }), _vm._v("\nhandle to catch the rings as we darted around the jousting courses on our horse — a la Knight Errant style. In fact we were not alone in this predilection towards medieval pagentry. Others of the youthful South, engaged in joustings and had for years, prior to the Civil War, all modeled on Sir Walter Scott's stories.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.44.1.0.box.116.371.1322.317.q.60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.44.2.0.box.115.772.1324.1515.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.44.2.0.box.255.772.1041.45.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Entertainment, ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Sports ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("And ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Social ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Affairs ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.2.1.box.116.860.1323.378.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.3.0.0"
    }
  }), _vm._v("Because travel was slow and rather difficult, those who lived on plantations had to be largely self-contained in the matter of entertainment. With no picture shows, radio, or automobiles, we had to get along with far less outside diversion than now seems necessary. There were no \"utilities,\" no electric service, no gas, no city water, no telephones and few conveniences, but life had its gaieties.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.2.2.box.116.1258.1323.474.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.3.1.0"
    }
  }), _vm._v("One of our forms of amusement was horseracing. The races were mostly trotting races in which the driver sat closeup behind his horse, legs stretched out to a kind of stirrup in the shafts, in a light and very uncomfortable looking racing sulky. It so happened that the course used most often was on the main river road in front of our plantation. This road was selected because it afforded a good, straight mile-course, with no curves, and was wide enough for racing vehicles to pass each other.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.2.3.box.115.1758.1324.529.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.3.2.0"
    }
  }), _vm._v("On race days, usually Saturday afternoon, people would flock to our Retreat Plantation levee, which elevation formed an excellent grand-stand. It would of course be specially crowded nearest the finishline. I remember vividly two of the main contenders. One was Mr. James A. Ware, a handsome, wealthy planter from the great Belle Grove Plantation near the town of White Castle about twenty miles below us. The other was Mr. Nahun L. Bruce, a well-known and plucky merchant from Plaquemine, five miles away. The two, driving their own horses, raced at terrific speed. Their two mag"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.45.1.0.box.132.367.1314.101.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _vm._v("nificent steeds would come thundering down the home stretch amid great acclaim.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.45.1.0.box.130.367.1325.1908.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.1.box.130.480.1316.434.q.60"
    }
  }, [_vm._v("A famous race I recall was that between Mr. Bruce's mare, \"Lady\", and a splendid looking horse owned by my cousin, Mr. William Schlater. \"Lady\" won the best two out of three. It was pleasing to us to be able to have ringside seats on the levee by merely walking out to the river-road. No admission charge, plenty of excitement, betting on the race (but no betting for us), pop selling, popcorn, the inevitable organ grinder with his monkey, and the jolly crowd.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.2.box.134.926.1315.366.q.60"
    }
  }, [_vm._v("Most of our entertainment came through attending the few traveling stage-shows, political rallies and lectures held in Plaquemine at the \"Opera House\" or on the open square in the center of the town. Showboats or \"Floating Palaces\" came along occasionally, but during my time there was not much of this. My father in his day was quite a good actor, frequently appearing in amateur shows in Plaquemine.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.3.box.134.1303.1317.424.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.3.0"
    }
  }), _vm._v("Once in a while medicine-men, patent medicine sellers, came along with their \"Kickapoo Indian Shows.\" I will never forget the various wild contortions of these, buckskin-clad, tomahawk handlers, their fierce, blood curdli"), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.4.0"
    }
  }), _vm._v("ng Indian yells, and — as these subsided — the fakers' efforts to sell patent-medicine. These outdoor exhibitions usually took place on a roughly-built, raised platform, from which the Kickapoo-medicine salesman afterward proclaimed the merits of his wares.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.4.box.137.1742.1317.475.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.5.0"
    }
  }), _vm._v("The medicine man would make an amazing spiel, or \"pitch\" as it is now called — a somehow believable story of his cureall. He would have a big brown bottle in his hand with a large stock, well displayed on the platform. Always he had an excellent voice and a friendly personality. Dozens of bottles of the \"wonderful\" Indian herb prescription would be sold. All the buyers got was often a raw alcohol concoction mixed with water and flavored with green herb bitters. It merely intoxicated, worked as a "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("narcotic ")]), _vm._v("and did not cure anything.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.5.box.191.2230.1264.45.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.6.0"
    }
  }), _vm._v("Modern spielers are often reminiscent of the old-time patent"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.46.1.0.box.137.373.1322.146.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  }), _vm._v("\nmedicine men with their exciting Kickapoo Indian yells, fiery incantations and then the ingratiating \"pitch\" of the master salesman.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.46.1.0.box.130.373.1329.1912.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.1.box.135.544.1322.436.q.60"
    }
  }, [_vm._v("As a little lad I once saw one of these medicine salesmen mounted on a box haranguing the colored folks in the confines of our plantation \"quarters.\" In a nearby cabin lay a poor colored boy dying of tuberculosis — consumption as we called it in those days. This heartless faker, after making his lying appeal, took the last dollar this poor emaciated youth possessed. To do this, he had to go into the cabin and harangue the sick boy as he lay dying in his bed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.2.box.132.996.1326.755.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.2.0"
    }
  }), _vm._v("A feature of the old days was the frequent passing on the main road of little bands of romantic-looking gypsies. They too practiced a genial rascality, telling fortunes and selling nostrums. They often camped for the night on our levee front with campfires lighted, near the big trees. More stable and honest passersby were the occasional peddler with packs on their backs. Selling trinkets, cheap jewelry, and ten-centstore gew gaws, some of these later developed into important businessmen with large stores in New Orleans or elsewhere. Most of these travelers who camped by night near the levee, particularly the peripatetic immigrant workers, carried dangerous-looking double-barrelled shotguns. For hunting game, self-defense, or maybe something more sinister, these guns looked quite formidable.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "101%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.3.box.130.1766.1325.519.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.3.0"
    }
  }), _vm._v("The social life of plantation people was limited, and yet there were always a few families of proud lineage who were careful in their social contacts. Among the dear friends of my family were the Randolphs, of "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Forest ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Home, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Nottaway ")]), _vm._v("and "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Blythewood ")]), _vm._v("plantations to the south of us at Bayou Goula. M. Liddell, son of the highly placed former Virginian, John Hampden Randloph, was my father's very close friend. \"Nottaway\" the imposing looking Randolph-built home is still considered one of the finest and largest of the great plantation homes on the river. The ball-room in this 40-room-house is one"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.47.1.0.box.134.367.1316.441.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  }), _vm._v("\nof the finest, and most luxurious of the kind I have seen in the south. The Iberville Parish authority, Edward Gay, says that both Nottaway, and the elegant and spacious old colonial type Gay manor house at St. Louis Plantation, were built in the same year, 1856 or 1857. These were prosperous years and planters had good crops along with high prices. In the golden decade before the Civil War many of the beautiful homes along the Mississippi River were constructed.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.47.1.0.box.134.367.1338.1908.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.1.box.140.824.1322.721.q.60"
    }
  }, [_vm._v("Later, a young scion of the family, M. Liddell, son of John Hampden Randolph, established himself comfortably and happily in his lovely "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Blythewood ")]), _vm._v("home, on the plantation of that name in the rear of the Bayou Goula settlement. It was there that I went to weekend parties and was captivated by the gracious manner of living and the lovely people who made up the big Randolph-Conner family. There was a cutoff road from the rear of our place through "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dunboyne ")]), _vm._v("Plantation, thus reducing the distance to the Randolph place by many miles. The story goes that my father in driving home from a dance at Nottaway, on this unfrequented road ran over a sleeping cow. The cow got up quickly and turned the buggy over. Badly shaken, he was not hurt seriously.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.2.box.149.1566.1318.371.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Nottaway ")]), _vm._v("still stands, and the present owners have kept the great and imposing-looking mansion in good repair. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Blythewood, ")]), _vm._v("the smaller Randolph home, burned to the ground as the family barely escaped with their lives. Many beautiful heirlooms belonging to the Randolphs perished in the flames. The house took fire in the dead hours of the night and before help could arrive everything was destroyed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.3.box.155.1956.1317.319.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.3.0"
    }
  }), _vm._v("It is thought that many lovely old southern homes were destroyed by fire because of defective chimneys. After many years of use, the mortar around the bricks in the chimneys, particularly in the upper part which goes through the attic, has a tendency to disintegrate, leave an opening between the bricks. Quite frequently the joists or other supports are an"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.48.1.0.box.134.372.1327.988.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0"
    }
  }), _vm._v("chored in the outer edge of this chimney masonry. When sparks finally reach these dry-as-tinder wooden supports, a fire starts in the attic and gains such headway that, out in the country, nothing can be done to save the home. That is the way we explain the loss of the more-than-a-century-old Clement home at Retreat, so dear to us. From what the farmer who lived in the much emasculated old house, after we had moved away from the country, later told us about the fire it is reasonable to suppose this is what happened. Our house was much changed in looks before it burned. My recently deceased cousin, George Bright of New Orleans, and I used to visit the old place, and wander nostalgically through the rooms, but we found the house a little difficult of recognition. The two \"sells\" had long been taken down, the lovely front garden demolished. The drastic change in general appearance was partly caused by the levee having been moved in almost a half mile, due to encroachment by the great and always changing Mississippi.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.48.1.0.box.130.372.1331.1925.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.1.1.box.130.1376.1325.921.q.60"
    }
  }, [_vm._v("One of the many pleasing recollections that come to me is my memory of the old Pleyel upright piano in our plantation living room and the joy it often gave a small boy with a love for music. At times when our visitors included Cousins Lottie and Nettie Miller from New Orleans, Anna Gay, her two sisters and her brother Andrew would spend the evening with us. Andrew would always bring his banjo to enliven the proceedings. It was then we heard our first college songs, very enchanting indeed. As I read Anna Gay's (now Mrs. McClung) reference to the Retreat Plantation musical group of long ago when Uncle Charles Clement, deceased before my time, used to play the flute, with his sister Lodoiska accompanying on the Pleyel, it reminded me of later days when we used to visit Aunt Lodo at her lovely home following Uncle Andrew Gay's death. She was then well up in the eighties. Even so our remarkable aunt would say, \"William, don't you want to hear me play the piano?\" I, of course, would quickly assent. Then,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.49.1.0.box.132.365.1316.219.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.0.0"
    }
  }), _vm._v("\nshe would dash off a brilliant piece of music with zest "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sacre ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("feu, ")]), _vm._v("and wonderful technique. Until shortly before Aunt Lodo's death, at the age of 90 whenever I called she would always play the piano for me.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.49.1.0.box.132.365.1319.908.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.1.box.134.601.1317.672.q.60"
    }
  }, [_vm._v("In our \"Retreat\" living room, there was a rather striking looking bust of the famous physician, Dr. Luzenberg. It occupied a commanding position above the old-fashioned writing desk. We were told that the deceased doctor was an especially good friend of Grandfather Clement. Later when I came to New Orleans and learned that Dr. Luzenberg's son (a prominent attorney and later district attorney of the parish) was named Chandler Clement Luzenberg, I appreciated the impress of our grandfather's character on other people. I had heard also of his friendship with the then prominent and wealthy, Story family of Saxonholm plantation and New Orleans. Later I was to meet a Mr. Clement Story* who, it seems"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.50.1.0.box.143.373.1322.218.q.70"
    }
  }, [_vm._v("\nwas also named in honor of my progenitor, the owner of Retreat Plantation, another tribute to the worth and potent character of Dr. Clement and evidence of his wide professional and business connections throughout Louisiana.")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "block.49.2.0.box.136.1351.1319.936.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.2.0.box.137.1351.1318.411.q.60"
    }
  }, [_vm._v("*After the publication of this book in 1952 I was pleasantly surprised one morning to be called upon by Mr. Henry Clement Story of New Orleans. I learned that he was a direct descendant of Henry Clement, brother of my grandfather, Dr. Charles Clement. This Henry, however, was named after "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("his ")]), _vm._v("grandfather, Gen. Henry Clement Story. On page 133 there appears a letter written to a relative just before the Battle of New Orleans in January 1815 by Mrs. E. Clement, wife of Henry Clement of New Orleans. I thus knew of the early Henry but did not know it was his daughter who married Benjamin Story, New Orleans' first banker and progenitor of the well known Story family.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.2.1.box.136.1780.1318.285.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.1.0"
    }
  }), _vm._v("One of Benjamin Story's sons, a West Pointer, rose to high distinction. He was General Henry Clement Story of the U.S. Army. When secession started and the \"War between the States\" loomed, Gen. Robert E. Lee endeavored to persuade Gen. Story to take sides with the Confederates. This he felt he could not do. On the other hand his wife and family were supporters of the Southern cause and a terrible rift was certain if he took part on the Northern side.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.2.2.box.137.2084.1318.203.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.2.0"
    }
  }), _vm._v("Gen. Story explained the circumstances and laid the matter before President Lincoln. It was then decided that he should, as a \"Neutral\", "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("retire ")]), _vm._v("to his Louisiana Plantation, a few miles below New Orleans. From his grandson, Henry Clement Story, I learned that when the Federal gunboats breached the New Orleans defenses, and steamed up the river, they"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.2.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "para.50.2.0.box.132.1907.1321.75.q.70"
    }
  }, [_vm._v("\nwere surprised to note a plantation home in front of which flew "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("both ")]), _vm._v("the Union and Confederate flags.")])]), _c('a', {
    attrs: {
      "id": "GBS.PA27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.50.1.0.box.134.373.1331.1469.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.1.box.139.611.1325.504.q.60"
    }
  }, [_vm._v("The use of telephones in Iberville began about 1886. I remember the erection of the first poles in front of our plantation and the stringing of the wires. All this was quite a curiosity, of course, and we—in our immaturity—greeted it with the doubt and contempt any such fool enterprise should properly merit. People like us, with swift horses always ready could send messages, or visit around at will. We were getting along fine, saw no use for crazy innovations such as telephones. It was just a fad and would soon die out.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.2.box.134.1133.1326.709.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.2.0"
    }
  }), _vm._v("Shortly after the line was installed I was contentedly whiling away a rainy, stormy afternoon, helping to shell corn for the mules and horses in the big stable along-side the riverroad, close to and almost up against the new telephone line. All of a sudden there was a terrific thunder-clap, a blinding light and a rending noise. I thought the Judgment Day had come. Realizing that I was all right, I rushed out of the barn to find that the poor, new telephone line was in ruins. Not knowing much about lightning arresters in those early days, they had built the line without necessary protection. For the first time I saw great poles still standing, but split like kindling wood, some pieces thrown clear across the levee. A small boy pondered over the foolishness of men and their gadgets."), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.51.1.0.box.134.367.1310.47.q.70"
    }
  }, [_vm._v("\nHe was glad he got off with nothing worse than a bad scare.")])]), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "block.50.2.0.box.130.1907.1324.377.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.2.1.box.130.1998.1324.286.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.1.0"
    }
  }), _vm._v("A boat was immediately sent ashore to investigate. They were met at the landing by Gen. Story in his general's uniform. The officer in charge saluted, and was quickly shown the \"Neutrality\" paper by Pres. Lincoln. As a consequence Story's plantation suffered no depredation. In fact the Federal Commander placed guards around the property to see that no damage was done. All of the surrounding plantations lost much of their stock, equipment and stores requisitioned by the conquering Federal forces.")]), _c('a', {
    attrs: {
      "id": "GBS.PA28"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA28"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.51.1.0.box.131.367.1321.1492.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.1.box.131.430.1319.602.q.60"
    }
  }, [_vm._v("The main barn and its big bins of corn and oats, racks of hay, and room for the stock to seek shelter, was evidence that we of Retreat used to raise all the food for our many draft animals, riding horses, cows, sheep and other animals. We developed our own motive power on the farm. There was no buying of gasoline or crude oil to run machines. We were a good balanced economy, a self-contained unit. The machine age with tractors, cultivators and harvesters of course, was changing all that. Whether for better or worse only time can tell. The annual harvest of oats was made by the use of hand-operated sickles.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.2.box.135.1049.1317.810.q.60"
    }
  }, [_vm._v("When I was about 10 years, I once went out to show the men how to properly garner the grain. Reaching out with the left hand to gather in a great bunch of grain, I then gave a swift pull with the right hand of the sharp sickle, to cut the oat stalks. My mistake, however, was in not cutting lower than the handgrip. Three fingers of my left hand caught the full cutting impact of the sharp blade. With my fingers deeply gashed, apparently nearly off, and a hand gushing blood, I rushed home across the pasture. With the application of large amounts of the much-used spider web—a blood stancher supposed to have some mysterious quality—the bleeding stopped, and my fingers in a short while were quickly healed. That oat-field scar, however, I have carried to this day. A reminder ever before me as it is even at this writing—how "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _vm._v("to do things.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.51.2.0.box.136.1925.1316.353.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.51.2.0.box.472.1925.642.37.q.100"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.0.0"
    }
  }), _vm._v("Old-time ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Living ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Conditions ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.2.1.box.136.2015.1316.263.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.3.0.0"
    }
  }), _vm._v("I learned to read—indeed some of my best reading was done by coal oil (\"insurance\" oil it was called) lamps—which needed daily filling and trimming and whose wicks gave strange, and devious trouble, sometimes smoking horribly and disastrously, throwing forth a sooty deposit. Our household"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.52.1.0.box.130.375.1331.567.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.0.0"
    }
  }), _vm._v("\nmenage was quite innocent of plumbing—in fact we had none at all. Drinking water came from the immense, unscreened cistern, partly open at the top for air ventilation. It held the rain water which ran off the roof of the house. Sometimes, to our consternation \"wiggle tails\" were found in large numbers. Small snakes occasionally got into the big wooden, rainwater reservoir. Fortunately these were the harmless kind that disported themselves, obligingly, on the water surface, where we could in our righteous indignation quickly get at them.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.52.1.0.box.130.375.1358.1916.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.1.1.box.143.956.1335.842.q.60"
    }
  }, [_vm._v("During the old days there were no window or door screens to keep out flies and mosquitoes. We got along with palmetto fans, used mosquito \"bars\" or netting over the beds. Thankful indeed were we for that haven of rest from the annoying, irritating and blood-sucking mosquitoes. The first screened porch, or \"gallery mosquito house\" erected in our section about 1888 was at the Plaquemine home of our Uncle Jacob McWilliams. Only this porch was screen-protected, nowhere else were they used in the house. In the summer it was a popular spot—indeed quite a step forward in home comfort. The first bathroom, too, was quite a curiosity. Somehow I at first looked upon that new innovation as \"sissy,\" encouraging softness. I saw one at the home of our more affluent uncle, Andrew H. Gay, Sr., where this epochal installation first came to my notice.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.1.2.box.159.1797.1329.494.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.2.0"
    }
  }), _vm._v("If we were hot, we thought nothing of it, we either stayed hot or cooled off with palmetto fans. Never did we seem to miss the electric fans of the future or air-conditioning now so essential in some quarters. If we were cold we summoned yardman Anthony to come with more armfuls of wood for the big log-fire. We then moved in closer. If no objections were raised the boys liked to stand in front of the fire—warm their backs, very delightfully. When Saturday night came we did not turn on the hot and cold water. Instead we luxuriated in"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.53.1.0.box.130.365.1316.333.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.0.0"
    }
  }), _vm._v("\nthe embrace of a big tin bathtub, carried into the bedrom for that purpose—the portable kind, with a raised, roundish back and curved arm rests. Something a good deal nicer to use than the ordinary, round washtub of the laundry type. A refinement that, at the time it came into use was probably thought to be quite an advance in bath technique.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.3.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA30"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.53.1.0.box.130.365.1316.333.q.60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.53.2.0.box.132.765.1318.1505.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.53.2.0.box.587.765.404.38.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Change ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("In ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Ideals ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.2.1.box.132.854.1317.1031.q.60"
    }
  }, [_vm._v("In the old South, as \"Lanterns On The Levee\" signalled so fatefully to us, we have \"lost the old ideals, the old strength.\" But there's time ahead, and believing that there is an underlying, God-denying, and entirely correctable reason for this disintegration, it is pleasing to read a recent Roger Babson news letter, in which he says quite cogently, that the answer will come through fundamental work now going on in the sphere of scientific human research. Through the study of Man, much neglected in the past, we can and must develop a science of living, both for the rural and city dweller. We must discover what \"environmental stimuli and idealized goals are universally acceptable.\" While Babson does not go into that particular phase, it is reasonable to suppose that land-use, and man's more equitable and \"satisfied relation\" adjustment to the land and natural resources of his country, will be an important phase of this great study. A glimpse of the old plantation, self-contained way of life may be of help as we go along with this idea and influence the changes which perforce are coming.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.2.2.box.132.1902.1318.368.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.3.1.0"
    }
  }), _vm._v("Nobility of character"), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA1.w.0.0.0"
    }
  }), _vm._v(", love and compassion, beauty and innocence are not lost, they "), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA1.w.1.0.0"
    }
  }), _vm._v("will return. It is sa"), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA1.w.2.0.0"
    }
  }), _vm._v("id that the great Henry Ford Foundation co"), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA1.w.3.0.0"
    }
  }), _vm._v("ntemplates a thorough"), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA1.w.4.0.0"
    }
  }), _vm._v(" study of these matters. Certainly, to sur"), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA1.w.5.0.0"
    }
  }), _vm._v("vive we must concern "), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA1.w.6.0.0"
    }
  }), _vm._v("ourselves very vitally with the great prob"), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA1.w.7.0.0"
    }
  }), _vm._v("lem of our time—our natural resources"), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA2.w.0.0.0"
    }
  }), _vm._v(" and human relationships. It is good to know that those engaged"), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA2.w.1.0.0"
    }
  }), _vm._v(" in research like the"), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA2.w.2.0.0"
    }
  }), _vm._v(" Babson, Ford,"), _c('a', {
    attrs: {
      "id": "GBS.PA30-IA2.w.2.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.56.1.0.box.132.372.1322.268.q.60"
    }
  }, [_vm._v("\nand other organizations who seek to benefit mankind, feel as they do about this great problem. As I look back rather delightfully, into the old days and study the manner of living of other times, it seems to me that we must take from the past much that will help men of today.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA30-IA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.54.0.0.box.0.0.1589.2565.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0016.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0.4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA30-IA2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.55.0.0.box.111.315.1409.2046.q.0"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0.5"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0017.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0.6"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA31"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.56.1.0.box.132.372.1322.268.q.60"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0.7"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55149bb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0018.vue
// module id = 66
// module chunks = 0